module.exports = __webpack_public_path__ + "static/webhook-34ff68f98b417cb4afc5e4d5a235051d.svg";